import React, { createContext, useContext, useState, useCallback } from 'react';

const BankrollMismatchContext = createContext();

export const useBankrollMismatch = () => {
    const context = useContext(BankrollMismatchContext);
    if (!context) {
        throw new Error('useBankrollMismatch must be used within a BankrollMismatchProvider');
    }
    return context;
};

export const BankrollMismatchProvider = ({ children }) => {
    const [shouldCheckMismatch, setShouldCheckMismatch] = useState(false);

    const triggerMismatchCheck = useCallback(() => {
        setShouldCheckMismatch(prev => !prev);
    }, []);

    const value = {
        shouldCheckMismatch,
        triggerMismatchCheck
    };

    return (
        <BankrollMismatchContext.Provider value={value}>
            {children}
        </BankrollMismatchContext.Provider>
    );
}; 